export default __webpack_public_path__ + "static/media/wall.a4debc50.jpg";